import requstHelper from './requstHelper';

class serviceApi {
  // 默认构造函数
  constructor() {
    return this;
  }

  // 医生站用户登录
  static loginYSZ = (params) => {
    const myParams = params;
    myParams.areaCode = 'NXT'
    myParams.companyCode = 'NXT-GS'
    return requstHelper.fetch('/accounts/login', myParams, {});
  }
}

export default serviceApi;



// WEBPACK FOOTER //
// ./src/common/service/serviceAPI.js